/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react'
import React from 'react'
import { useOpenGroupedMapPoints } from '../../utils/routes/modals/modalsActions'

const GroupedPinWrapper = ({ children, items, ...props }) => {
  const style = css`
    display: block;
    transition: all 0.1s ease-in-out;
    z-index: 1;
    position: absolute;
    transform: translate(-50%, -50%);
    background-color: #2f54eb;
    border-radius: 50%;
    width: 38px;
    height: 38px;
    color: white;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    &:hover {
      z-index: 5;
      transform: translate(-50%, -50%) scale(1.2, 1.2);
    }
  `
  const open = useOpenGroupedMapPoints()

  return (
    <a css={style} {...props} onClick={() => open(items)}>
      {items.length}
    </a>
  )
}
export default GroupedPinWrapper
